import { action, computed } from 'mobx';
import { observer } from 'mobx-react';
import { bind, InfiniteScroll, Modal, ModalHandle } from 'Mri.Web.Common';
import * as React from 'react';
import { BsArrowRepeat } from '@react-icons/all-files/bs/BsArrowRepeat';
import { Link } from 'react-router-dom';
import { DisplayListViewModel } from '../DisplayFilters/DisplayListViewModel';

export interface IDisplaySelectorCardProps {
    readonly vm: DisplayListViewModel;
    readonly modalHandle: ModalHandle;
    readonly manifestGuid?: string;
}

@observer
export class ManifestConfirmModal extends React.Component<IDisplaySelectorCardProps> {
    public render() {
        const { vm, modalHandle } = this.props;
        const { hasMore, busy, loadMoreAsync, displays, total, checkedDisplays } = vm;

        return (
            <Modal
                className="modal-md"
                title={`Confirm scheduled update for ${
                    checkedDisplays.length > 0 ? checkedDisplays.length : total
                } Display(s)`}
                modalHandle={modalHandle}
                btnClass="w-50"
                footerClass="d-flex justify-content-center"
            >
                <div ref={this.setDisplayListContainer} style={{ overflowY: 'scroll', height: 300 }}>
                    <InfiniteScroll
                        throttle={100}
                        threshold={300}
                        hasMore={hasMore}
                        isLoading={busy}
                        container={this.displayListContainer}
                        onLoadMore={loadMoreAsync}
                    >
                        <div>
                            {this.displays.map(d => (
                                <div key={d.serialNumber}>
                                    {d.serialNumber}
                                    {d.linkedSoftwareUpdateManifests
                                        ?.filter(m => m.manifestGuid != this.props.manifestGuid)
                                        .map(
                                            linkedManifest =>
                                                linkedManifest && (
                                                    <div>
                                                        <span style={{ display: 'inline' }}> - </span>
                                                        <Link
                                                            to={`./${linkedManifest.manifestGuid}/status`}
                                                            target="_blank"
                                                        >
                                                            <span style={{ display: 'inline' }}>
                                                                {linkedManifest.manifestName}
                                                            </span>
                                                        </Link>
                                                    </div>
                                                )
                                        )}
                                </div>
                            ))}
                        </div>
                    </InfiniteScroll>
                    {busy && (
                        <div className="w-100 text-center">
                            <BsArrowRepeat className="" />
                        </div>
                    )}
                </div>
            </Modal>
        );
    }

    @bind
    @action
    private setDisplayListContainer(r: HTMLDivElement | null) {
        this.displayListContainer = r;
    }

    @computed
    private get displays() {
        if (this.props.vm.checkedDisplays.length > 0) {
            return this.props.vm.checkedDisplays.filter(d => d != undefined);
        } else {
            return this.props.vm.displays;
        }
    }

    private displayListContainer: HTMLDivElement | null = null;
}
